export const VIEW_TYPE = {
  DEFAULT: 'DEFAULT',
  STANDARD: 'STANDARD'
};
export const MAX_VIEWS_LIMIT = 50;